import React from 'react';
import { ButtonLarge } from '../buttons/ButtonLarge/ButtonLarge';

import './confirm-modal.css';

/**
 * Two-factor confirmation modal — used by the Account screen for
 * "Reset Quiz Data" and "Delete Account". Renders a ~65% black scrim
 * behind a centered card so the user's attention is pinned on the choice.
 *
 * @param {boolean} isOpen
 * @param {string} title - e.g. "Are you Sure?"
 * @param {string} message - e.g. "This can't be undone."
 * @param {string} cancelText
 * @param {string} confirmText
 * @param {function} onCancel
 * @param {function} onConfirm
 * @param {boolean} [isProcessing] - disables buttons + shows a busy confirm label
 */
export const ConfirmModal = ({
  isOpen,
  title,
  message,
  cancelText = 'Cancel',
  confirmText,
  onCancel,
  onConfirm,
  isProcessing = false,
}) => {
  if (!isOpen) return null;

  return (
    <div className="account-modal-overlay">
      <div className="account-modal-card">
        <h2 className="account-modal-title">{title}</h2>
        <p className="account-modal-message">{message}</p>
        <div className="account-modal-buttons">
          <ButtonLarge
            text={cancelText}
            buttonLargeClassName="button-large account-modal-cancel-button"
            onClick={onCancel}
            disabled={isProcessing}
          />
          <ButtonLarge
            text={isProcessing ? 'Working…' : confirmText}
            buttonLargeClassName="button-large account-modal-confirm-button"
            onClick={onConfirm}
            disabled={isProcessing}
          />
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
